<div class="container-fluid test-execution">
  <div class="row warning-msg">
    <div class="w-auto">
      <span>{{ warningMessage }}</span>
    </div>
  </div>
  <div *ngIf="isDataLoaded" class="row mx-0 px-0">
    <div class="col-3 mx-0 px-0">
      <div class="row mx-0">
        <div class="col-9 px-0">
          <div class="row mx-2 search-tree">
            <input
              type="text"
              class="search-input form-control"
              [(ngModel)]="planTreeSearch"
              (keyup)="modifyPlansTree()"
              placeholder="Search Test Plans"
            />
          </div>
          <div class="row mx-2 tree-container">
            <app-tree-view
              class="w-100"
              [nodes]="
                planTreeSearch != '' ? planSearchResults : testPlanTreeData
              "
              [selectedNode]="selectedPlan"
              [idName]="testPlanTree"
              (menuItemSelected)="selectPlan($event)"
            ></app-tree-view>
          </div>
        </div>
        <div class="col-3 px-0">
          <div
            class="d-flex flex-column justify-content-center align-items-center row h-100"
          >
            <button
              class="arrow-btn mb-2"
              (click)="moveSelected('plan')"
              [disabled]="!selectedPlan.dragable"
            >
              <img
                src="assets/images/virtusa-icons/arrow-right.svg"
                alt="arrow-icon"
                class="button-icon"
              />
            </button>

            <button
              class="arrow-btn"
              (click)="moveSelected('remove', 'plans')"
              [disabled]="selectedPlans.length === 0"
            >
              <img
                src="assets/images/virtusa-icons/arrow-left.svg"
                alt="arrow-icon"
                class="button-icon"
              />
            </button>
          </div>
        </div>
      </div>
      <div class="row mx-0 mt-4">
        <div class="col-9 px-0">
          <div class="row mx-2 search-tree pt-0">
            <input
              type="text"
              class="search-input form-control"
              [(ngModel)]="caseTreeSearch"
              (keyup)="modifyCaseTree()"
              placeholder="Search Test Cases"
            />
          </div>
          <div class="row mx-2 tree-container">
            <app-tree-view
              class="w-100"
              [nodes]="
                caseTreeSearch != '' ? caseSearchResults : testCaseTreeData
              "
              [selectedNode]="selectedCase"
              [idName]="testCaseTree"
              (menuItemSelected)="selectCase($event)"
            ></app-tree-view>
          </div>
        </div>
        <div class="col-3 px-0">
          <div
            class="d-flex flex-column justify-content-center align-items-center row h-100"
          >
            <button
              class="arrow-btn mb-2"
              (click)="moveSelected('case')"
              [disabled]="!selectedCase.dragable"
            >
              <img
                src="assets/images/virtusa-icons/arrow-right.svg"
                alt="arrow-icon"
                class="button-icon"
              />
            </button>

            <button
              class="arrow-btn"
              (click)="moveSelected('remove', 'cases')"
              [disabled]="selectedCases.length === 0"
            >
              <img
                src="assets/images/virtusa-icons/arrow-left.svg"
                alt="arrow-icon"
                class="button-icon"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-9 d-flex flex-column mb-3">
      <div class="row mx-0 justify-content-between mb-2">
        <div class="col-6 px-0 accello-general-text6 v-center">
          Selected Test Plans & Test Cases
        </div>
        <div class="col-3">
          <!-- <app-dropdown-with-sections
            [config]="agentConfig"
            [fields]="agentSections"
            [selectedValue]="agentValue"
            (onSelect)="updateGlobalAgent($event)"
          ></app-dropdown-with-sections> -->

          <app-menu-dropdown
            [selectedValue]="agentValue"
            [placeholderText]="'Add global device/execution engine'"
            [data]="globalEngines"
            (onSelect)="updateGlobalAgent($event)"
          >
          </app-menu-dropdown>
        </div>
        <div class="col-3">
          <app-dropdown-with-sections
            [config]="browsersConfig"
            [fields]="browsersSections"
            [selectedValue]="browserValue"
            (onSelect)="updateGlobalBrowser($event)"
          ></app-dropdown-with-sections>
        </div>
      </div>

      <div
        class="row mx-0 table-container px-0 shadow flex-grow-1"
        cdkDropList
        id="start-execution-table"
        [cdkDropListConnectedTo]="['test-case-tree', 'test-plan-tree']"
        (cdkDropListDropped)="drop($event)"
      >
        <app-zorro-table
          tableId="test-exec"
          class="w-100 px-0"
          [columns]="columns"
          [data]="dataSource"
          [options]="tableOptions"
          (handleActions)="handleActionsInTable($event)"
          (onRowSelect)="handleSelect($event)"
        ></app-zorro-table>
      </div>
      <div
        class="d-flex justify-content-end mb-3 px-1 bottom-actions shadow align-items-center py-1"
      >
        <div class="d-flex flex-grow-1">
          <div class="toggle-wrap v-center px-2 rounded-1">
            <div class="d-flex">
              <div
                class="v-center accello-general-text-6"
                [ngClass]="{ highlight: isAnalysUp }"
              >
                Test Failure Analysis
              </div>
              <div class="form-check form-switch mx-2 v-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="isAnalysUp"
                  (change)="onSwitchChange($event)"
                  role="switch"
                  id="flexSwitchCheckChecked"
                />
              </div>
            </div>
          </div>

          <div class="toggle-wrap v-center px-2 rounded-1">
            <div class="d-flex">
              <div
                class="v-center accello-general-text-6"
                [ngClass]="{ highlight: isSelfHealingUp }"
              >
                Self-Healing
              </div>
              <div class="form-check form-switch mx-2 v-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="isSelfHealingUp"
                  role="switch"
                  id="flexSwitchCheckChecked"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="btn-accello-primary btn-accello mx-2"
          [matMenuTriggerFor]="menu"
        >
          <img src="assets/images/virtusa-icons/launch.svg" alt="launch" />
          Start Execution
          <div class="v-center">
            <mat-icon class="menu-icon">arrow_drop_down</mat-icon>
          </div>
        </button>

        <mat-menu #menu="matMenu" class="custom-menu-panel">
          <button mat-menu-item (click)="executionWithRelease()">
            With Release
          </button>
          <button mat-menu-item (click)="executionWithoutRelease()">
            Without Release
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <div *ngIf="!isDataLoaded" class="load-wrap v-center">
    <app-loading [text]="'Loading data'"></app-loading>
  </div>
</div>
